import { render } from "./PDF.vue?vue&type=template&id=4cc77bce&scoped=true"
import script from "./PDF.vue?vue&type=script&lang=js"
export * from "./PDF.vue?vue&type=script&lang=js"

import "./PDF.vue?vue&type=style&index=0&id=4cc77bce&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc77bce"]])

export default __exports__